import { API_HOST } from '@/lib/config'

/** Suffix the backend appends to original filenames for the resized variant. */
const THUMB_SUFFIX = '.thumb.jpg'

/**
 * Builds the URL for a product image. Defaults to the resized thumbnail
 * (~800px max edge, JPEG q80) which is plenty for list rows, POS cards, and
 * the detail page's 280px column. Pass `'original'` only when the user
 * explicitly opens a full-resolution view.
 */
export function getProductImageURL(
    imageURL: string | null | undefined,
    variant: 'thumb' | 'original' = 'thumb',
): string {
    if (!imageURL) return ''
    if (variant === 'original') return `${API_HOST}${imageURL}`
    return `${API_HOST}${imageURL}${THUMB_SUFFIX}`
}
